import * as LoginCandidatesConstants from "../constants/LoginCandidates";

const initialState = {
  isDone: false,
  isFetching: false,
  collection: []
};

export function loginCandidates(state = initialState, action) {
  switch (action.type) {
    case LoginCandidatesConstants.CLEAR:
      return Object.assign({}, state, {collection: initialState.collection, isDone: false});
    case LoginCandidatesConstants.FETCH_STARTED:
      return Object.assign({}, state, {collection: initialState.collection, isDone: false, isFetching: true});
    case LoginCandidatesConstants.FETCH_COMPLETED:
      return Object.assign({}, state, {isDone: true, isFetching: false, collection: action.tenants});
    default:
      return state;
  }
}
